export default __webpack_public_path__ + "fonts/Titillium_Web-300-latin-ext1.woff2";